import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startFetchingCreatedPreviewId = () =>
  produce((draft: Draft<State>) => {
    draft.createdPreviewId.fetching = draft.createdPreviewId.fetching + 1;
  });

export const setCreatedPreviewId = (createdPreviewId: string) =>
  produce((draft: Draft<State>) => {
    draft.createdPreviewId.data = createdPreviewId;
  });

export const finishFetchingCreatedPreviewId = () =>
  produce((draft: Draft<State>) => {
    draft.createdPreviewId.fetching = draft.createdPreviewId.fetching - 1;
  });

export const disposeCreatedPreviewId = () =>
  produce((draft: Draft<State>) => {
    draft.createdPreviewId.data = initialState.createdPreviewId.data;
    draft.createdPreviewId.fetching = initialState.createdPreviewId.fetching;
  });

export const startCreateReturnComment = () =>
  produce((draft: Draft<State>) => {
    draft.createdPreviewId.fetching = initialState.createReturnComment.fetching + 1;
  });

export const finishCreateReturnComment = () =>
  produce((draft: Draft<State>) => {
    draft.createdPreviewId.fetching = initialState.createReturnComment.fetching - 1;
  });
